import { RouteProps } from 'react-router';
import { TransmissionRequest } from './TransmissionRequest';
import TransmissionDownloadList from './TransmissionRequest/transmission-download-list';
import TransmissionRequestHolder from './TransmissionRequest/transmission-request-holder';
import TransmissionRequestSuccess from './TransmissionRequest/transmission-request-success';
import Faq from './faq';
import UpdatePan from './UpdatePan/index';
import UpdatePanList from './UpdatePan/update-pan-list';
import UpdatePanOtp from './UpdatePan/update-pan-otp';
import UpdatePanSelected from './UpdatePan/update-pan-selected';
import UpdatePanSuccess from './UpdatePan/update-pan-success';
import FaqSectionView from './faq/faqSectionView';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import ResetPin from '../dashboard/ResetPin';
import transmissionRequestOtpEmail from './TransmissionRequest/transmission-request-otp-email';
import transmissionRequestOtpMobile from './TransmissionRequest/transmission-request-otp-mobile';
import TransmissionRequestPan from './TransmissionRequest/transmission-request-pan';
import Purchase from '../dashboard/commercial/ExploreMFs';
import ExploreMfDetails from '../dashboard/commercial/ExploreMFs/explore-mf-details';
import { ExplorePaths } from '../dashboard/commercial/ExploreMFs/types';
import ExploreMFFilters from '../dashboard/commercial/ExploreMFs/explore-mf-filters';
import { TransferOfUnits } from '../dashboard/makeNct/TransferOfUnits';

export const QuickLinks: RouteProps[] = [
    {
        path: '/update-pan',
        component: UpdatePan,
    },
    {
        path: '/update-pan-otp',
        component: UpdatePanOtp,
    },
    {
        path: '/update-pan-list',
        component: UpdatePanList,
    },
    {
        path: '/update-pan-selected',
        component: UpdatePanSelected,
    },
    {
        path: '/update-pan-success',
        component: UpdatePanSuccess,
    },
    {
        path: '/transmission-request',
        component: TransmissionRequest,
    },
    {
        path: '/transfer-of-units',
        component: TransferOfUnits,
    },
    {
        path: '/transmission-request-otp-mobile',
        component: transmissionRequestOtpMobile,
    },
    {
        path: '/transmission-request-otp-email',
        component: transmissionRequestOtpEmail,
    },
    {
        path: '/transmission-request-holder',
        component: TransmissionRequestHolder,
    },
    {
        path: '/transmission-request-pan',
        component: TransmissionRequestPan,
    },
    {
        path: '/transmission-download-list',
        component: TransmissionDownloadList,
    },
    {
        path: '/transmission-request-success',
        component: TransmissionRequestSuccess,
    },
    {
        path: '/faq',
        component: Faq,
    },
    {
        path: '/faq-section',
        component: FaqSectionView,
    },
    {
        path: '/privacy-policy',
        component: PrivacyPolicy,
    },
    {
        path: '/terms-of-use',
        component: TermsOfUse,
    },
    {
        path: '/reset-pin',
        component: ResetPin,
    },
    {
        path: ExplorePaths.NewPurchase,
        component: Purchase,
    },
    {
        path: ExplorePaths.Explore,
        component: ExploreMFFilters,
        exact: true,
    },
    {
        path: ExplorePaths.SchemeDetails,
        component: ExploreMfDetails,
        exact: true,
    },
];
